import { NavLink, Outlet, useNavigate } from "react-router-dom";
import { useAuthStore } from "@/store/auth";

const NAV_ITEMS = [
  { to: "/", label: "ダッシュボード" },
  { to: "/fetch", label: "受注取得" },
  { to: "/allocate", label: "出荷実績取込" },
  { to: "/print", label: "印刷実行" },
  { to: "/fulfillment", label: "発送完了" },
  { to: "/orders", label: "受注一覧" },
  { to: "/errors", label: "エラー" },
];

export default function Layout() {
  const { username, logout } = useAuthStore();
  const navigate = useNavigate();
  const handleLogout = () => {
    logout();
    navigate("/login", { replace: true });
  };

  return (
    <div className="min-h-screen flex flex-col">
      <header className="bg-brand-primary text-white">
        <div className="max-w-7xl mx-auto px-4 py-3 flex items-center justify-between">
          <h1 className="text-xl font-bold">Wonect Picking System</h1>
          <div className="flex items-center gap-4 text-sm">
            <span>ユーザー: {username ?? "-"}</span>
            <button
              type="button"
              onClick={handleLogout}
              className="px-3 py-1 bg-white/10 hover:bg-white/20 rounded"
            >
              ログアウト
            </button>
          </div>
        </div>
      </header>

      <nav className="bg-white border-b shadow-sm">
        <div className="max-w-7xl mx-auto px-4">
          <ul className="flex gap-1 overflow-x-auto">
            {NAV_ITEMS.map((item) => (
              <li key={item.to}>
                <NavLink
                  to={item.to}
                  end={item.to === "/"}
                  className={({ isActive }) =>
                    `inline-block px-4 py-3 text-sm font-medium whitespace-nowrap border-b-2 ${
                      isActive
                        ? "border-brand-accent text-brand-primary"
                        : "border-transparent text-gray-600 hover:text-gray-900"
                    }`
                  }
                >
                  {item.label}
                </NavLink>
              </li>
            ))}
          </ul>
        </div>
      </nav>

      <main className="flex-1 max-w-7xl w-full mx-auto px-4 py-6">
        <Outlet />
      </main>

      <footer className="bg-gray-100 border-t text-xs text-gray-500">
        <div className="max-w-7xl mx-auto px-4 py-3">
          Wonect Picking System (Phase 1)
        </div>
      </footer>
    </div>
  );
}
